import React from "react";
import "./app.css";
import Calculator from "./components/Calculator";

function App() {
  return (
    <div className="app">
      <Calculator />
    </div>
  );
}

export default App;
